import { useEffect } from "react";
import { APP_VERSION } from "../config";

const INTERVAL = 60 * 1000; // 1 min

const useAutoUpdate = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, {
          cache: "no-store",
        });
        const data = await res.json();

        if (data.version !== APP_VERSION) {
          console.log("New version detected, reloading...");
          window.location.reload();
        }
      } catch (e) {
        console.error("Version check failed", e);
      }
    };

    checkVersion();
    const id = setInterval(checkVersion, INTERVAL);

    return () => clearInterval(id);
  }, []);
  return
};

export default useAutoUpdate;
